import { bool, func, number, string } from 'prop-types';
import React from 'react';

import withConfirm from '../../../../generic/with-confirm';
import { allStatusesEnum as invoiceStatuses } from '../../../constants';
import SubmitForReviewTooltipButton from './SubmitForReviewTooltipButton';

const ButtonWithConfirmation = withConfirm(
  'Do you really want to submit this invoice to accounting for review?',
)(SubmitForReviewTooltipButton);

export default function SubmitForReviewButton({
  onUpdateStatus,
  id,
  disabled,
  ...rest
}) {
  return (
    <ButtonWithConfirmation
      onClick={() => onUpdateStatus(id, invoiceStatuses.IN_REVIEW.value)}
      disabled={disabled}
      {...rest}
    />
  );
}

SubmitForReviewButton.propTypes = {
  onUpdateStatus: func.isRequired,
  id: number.isRequired,
  disabled: bool,
  title: string,
};

SubmitForReviewButton.defaultProps = {
  disabled: false,
  title: 'Submit for Accounting Review',
};
